<div class="layout-container" [ngClass]="containerClass">
    <div class="layout-content-wrapper" [style.--layoutContentWrapperMarginLeft]="layoutContentWrapperMarginLeft">
        <div class="layout-content" [style.--layoutContentMargin]="layoutContentMargin">
            <app-topbar *ngIf="!hideMainMenu"></app-topbar>
            <app-breadcrumb class="content-breadcrumb" *ngIf="!hideMainMenu"></app-breadcrumb>
            <div class="message-notifier-container">
                <p-messages class="message-notifier" key="msg" [escape]="false"></p-messages>
                <p-messages class="message-notifier" key="downgrade-dbc-error" [escape]="false" [closable]="false"></p-messages>
                <p-messages class="message-notifier" key="downgrade-chatbot-error" [escape]="false" [closable]="false"></p-messages>
            </div>
            <p-toast class="toast-notifier" key="tst" [style]="{marginTop: '70px'}"
            [preventOpenDuplicates]="true"></p-toast>
            <div class="is-loading-modal-background" *ngIf="cache.isLoading | async"></div>
            <p-progressSpinner class="is-loading-spinner" styleClass="custom-spinner" *ngIf="cache.isLoading | async"></p-progressSpinner>
            <router-outlet></router-outlet>
        </div>
        <div class="layout-mask" (click)="hideMenu()"></div>
        <!-- <app-footer></app-footer> -->
    </div>
    <app-profilemenu></app-profilemenu>
    <!-- <app-config></app-config> -->

</div>
